import React from 'react';
import {FormGroup, ControlLabel, FormControl} from 'react-bootstrap';
import {KeyboardArrowLeft, KeyboardArrowRight} from '@material-ui/icons';
import {DatePicker as MuiDatePicker} from '@material-ui/pickers';
import {TextField} from '@material-ui/core';
import moment from 'moment';

export class DatePicker extends React.Component {
  render() {
    const {
      input,
      label,
      required,
      placeholder,
      maxDate,
      minDate,
      helpText,
      meta: {error, warning, touched},
      initialValue,
      readOnly,
    } = this.props;

    let errorMessage;
    const validationState = (touched && error && 'error') || (warning && 'warning') || null;

    if (touched && (error || warning)) {
      errorMessage = <span className="help-block">{error || warning}</span>;
    }

    const asterisk = (required && <span className="form-field-required" />) || null;

    return (
      <FormGroup validationState={validationState}>
        {!readOnly ? (
          <React.Fragment>
            <ControlLabel>
              {label}
              {asterisk}
            </ControlLabel>
            <MuiDatePicker
              {...{
                ...input,
                format: 'MMMM DD, YYYY',
                value: input.value,
                onChange: (date) => input.onChange(date),
                onBlur: () => input.onBlur(input.value),
                autoOk: true,
                maxDate,
                minDate,
                leftArrowIcon: <KeyboardArrowLeft />,
                rightArrowIcon: <KeyboardArrowRight />,
              }}
            />
          </React.Fragment>
        ) : (
          <TextField
            {...{
              ...input,
              value: moment(input.value).format('MMMM DD, YYYY'),
              label: (
                <span>
                  {label} {asterisk}
                </span>
              ),
              placeholder,
              disabled: true,
            }}
          />
        )}
        {helpText && <span className="help-text">{helpText}</span>}
        {errorMessage}
        <FormControl.Feedback />
      </FormGroup>
    );
  }
}
